<template>
  <v-container fluid>
    <manpowermenubar_govem />
    <!-- ===== HEADER ===== -->
    <v-card flat class="mb-4 header-card">
      <v-card-title class="d-flex align-center py-3">
        <v-icon large color="indigo darken-2" class="mr-3"
          >mdi-account-group</v-icon
        >
        <div>
          <div class="text-h5 font-weight-bold indigo--text text--darken-2">
            รายงานกรอบอัตรากำลัง พนักงานราชการ
          </div>
          <div class="text-caption grey--text">
            ระบบบริหารจัดการกรอบอัตรากำลัง สำนักงานคณะกรรมการการอาชีวศึกษา
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          depressed
          @click="exportExcel"
          :loading="exporting"
          :disabled="positionList.length === 0"
        >
          <v-icon left>mdi-file-excel</v-icon>
          ส่งออก Excel
        </v-btn>
      </v-card-title>
    </v-card>

    <!-- ===== FILTERS ===== -->
    <v-card flat class="mb-4">
      <v-card-text class="pb-2">
        <v-row dense>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="filters.region_name"
              :items="filterOptions.regions"
              label="ภูมิภาค"
              clearable
              dense
              outlined
              hide-details
              prepend-inner-icon="mdi-map-marker-radius"
              @change="onRegionChange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="filters.province_name"
              :items="filteredProvinces"
              item-text="province_name"
              item-value="province_name"
              label="จังหวัด"
              clearable
              dense
              outlined
              hide-details
              prepend-inner-icon="mdi-city"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="filters.college_code"
              :items="filterOptions.colleges"
              item-text="college_name"
              item-value="college_code"
              label="สถานศึกษา"
              clearable
              dense
              outlined
              hide-details
              prepend-inner-icon="mdi-school"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="filters.name_postion"
              :items="filterOptions.positions"
              label="ตำแหน่ง"
              clearable
              dense
              outlined
              hide-details
              prepend-inner-icon="mdi-badge-account-horizontal"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense class="mt-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text color="grey" class="mr-2" @click="clearFilters">
              <v-icon left small>mdi-filter-remove</v-icon>
              ล้างตัวกรอง
            </v-btn>
            <v-btn color="indigo" dark depressed @click="fetchAllData">
              <v-icon left small>mdi-magnify</v-icon>
              ค้นหา
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ===== SUMMARY CARDS (row 1) ===== -->
    <v-row class="mb-2">
      <v-col cols="12" sm="6" md="3">
        <v-card flat class="summary-card total-card">
          <v-card-text class="text-center py-4">
            <v-icon size="36" color="indigo darken-1" class="mb-1"
              >mdi-clipboard-list</v-icon
            >
            <div class="text-h4 font-weight-bold indigo--text text--darken-1">
              {{ summary.total_positions | numberFormat }}
            </div>
            <div class="text-subtitle-2 grey--text text--darken-1 mt-1">
              อัตราทั้งหมด
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card flat class="summary-card occupied-card">
          <v-card-text class="text-center py-4">
            <v-icon size="36" color="teal darken-1" class="mb-1"
              >mdi-account-check</v-icon
            >
            <div class="text-h4 font-weight-bold teal--text text--darken-1">
              {{ summary.occupied_positions | numberFormat }}
            </div>
            <div class="text-subtitle-2 grey--text text--darken-1 mt-1">
              อัตราครอง
              <span v-if="summary.total_positions > 0" class="text-caption">
                ({{
                  (
                    (summary.occupied_positions / summary.total_positions) *
                    100
                  ).toFixed(1)
                }}%)
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card flat class="summary-card vacant-card">
          <v-card-text class="text-center py-4">
            <v-icon size="36" color="red darken-1" class="mb-1"
              >mdi-account-remove</v-icon
            >
            <div class="text-h4 font-weight-bold red--text text--darken-1">
              {{ summary.vacant_positions | numberFormat }}
            </div>
            <div class="text-subtitle-2 grey--text text--darken-1 mt-1">
              อัตราว่าง
              <span v-if="summary.total_positions > 0" class="text-caption">
                ({{
                  (
                    (summary.vacant_positions / summary.total_positions) *
                    100
                  ).toFixed(1)
                }}%)
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card flat class="summary-card retire-card">
          <v-card-text class="text-center py-4">
            <v-icon size="36" color="deep-orange darken-1" class="mb-1"
              >mdi-account-clock</v-icon
            >
            <div
              class="text-h4 font-weight-bold deep-orange--text text--darken-1"
            >
              {{ retirementSummary.retire_this_year | numberFormat }}
            </div>
            <div class="text-subtitle-2 grey--text text--darken-1 mt-1">
              เกษียณปีนี้ ({{ currentThaiYear }})
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ===== RETIREMENT FORECAST CARDS (row 2) ===== -->
    <v-card flat class="mb-4">
      <v-card-text class="py-3">
        <div class="d-flex align-center mb-3">
          <v-icon color="deep-orange" class="mr-2"
            >mdi-chart-timeline-variant-shimmer</v-icon
          >
          <span class="text-subtitle-1 font-weight-bold"
            >พยากรณ์เกษียณล่วงหน้า 5 ปี — อัตราที่จะว่างลง
            (สำหรับวางแผนเกลี่ยอัตรากำลัง)</span
          >
        </div>
        <v-row dense>
          <v-col
            v-for="item in retirementForecast"
            :key="item.year"
            cols="6"
            sm="4"
            md="2"
          >
            <v-card
              outlined
              class="text-center pa-3 forecast-chip"
              :class="{
                'forecast-chip--active': item.year === currentThaiYear
              }"
            >
              <div
                class="text-caption font-weight-medium grey--text text--darken-1"
              >
                พ.ศ. {{ item.year }}
              </div>
              <div
                class="text-h5 font-weight-bold deep-orange--text text--darken-1 my-1"
              >
                {{ item.count }}
              </div>
              <div class="text-caption grey--text">คน</div>
              <div
                class="text-caption font-weight-medium mt-1"
                :class="item.count > 0 ? 'red--text' : 'green--text'"
              >
                <v-icon x-small :color="item.count > 0 ? 'red' : 'green'">
                  {{ item.count > 0 ? "mdi-arrow-up" : "mdi-check" }}
                </v-icon>
                {{ item.cumulative }} สะสม
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ===== TABS ===== -->
    <v-card flat>
      <v-tabs v-model="activeTab" color="indigo" slider-color="indigo">
        <v-tab>
          <v-icon left small>mdi-view-list</v-icon>
          รายละเอียดอัตรา
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-account-clock</v-icon>
          <span>
            วิเคราะห์เกษียณ
            <v-badge
              v-if="retirementSummary.retire_this_year > 0"
              :content="retirementSummary.retire_this_year"
              color="deep-orange"
              inline
            ></v-badge>
          </span>
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-map</v-icon>
          สัดส่วนตามภูมิภาค
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-city-variant</v-icon>
          สัดส่วนตามจังหวัด
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-domain</v-icon>
          <span>
            สรุปตามสถานศึกษา
            <v-badge
              v-if="collegesWithVacancyCount > 0"
              :content="collegesWithVacancyCount"
              color="red"
              inline
            ></v-badge>
          </span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- ==================== TAB 1: รายละเอียดอัตรา ==================== -->
        <v-tab-item>
          <v-card-text>
            <v-data-table
              :headers="positionHeaders"
              :items="positionList"
              :loading="loading"
              :search="searchText"
              :items-per-page="15"
              :footer-props="{
                'items-per-page-options': [10, 15, 30, 50, -1],
                'items-per-page-text': 'แสดงรายการ'
              }"
              class="elevation-0 report-table"
              loading-text="กำลังโหลดข้อมูล..."
              no-data-text="ไม่พบข้อมูล"
              dense
              multi-sort
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchText"
                  label="ค้นหาในตาราง..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  dense
                  outlined
                  hide-details
                  class="mb-3"
                  style="max-width: 400px"
                ></v-text-field>
              </template>

              <template v-slot:item.position_status="{ item }">
                <v-chip
                  small
                  :color="
                    item.position_status === 'ครอง'
                      ? 'teal lighten-4'
                      : 'red lighten-4'
                  "
                  :text-color="
                    item.position_status === 'ครอง'
                      ? 'teal darken-3'
                      : 'red darken-3'
                  "
                  class="font-weight-medium"
                >
                  <v-icon left x-small>
                    {{
                      item.position_status === "ครอง"
                        ? "mdi-check-circle"
                        : "mdi-alert-circle"
                    }}
                  </v-icon>
                  {{ item.position_status }}
                </v-chip>
              </template>

              <template v-slot:item.full_name="{ item }">
                <span v-if="item.position_status === 'ครอง'">{{
                  item.full_name
                }}</span>
                <span v-else class="grey--text font-italic">- ว่าง -</span>
              </template>

              <!-- อายุ + สถานะเกษียณ -->
              <template v-slot:item.age_display="{ item }">
                <div v-if="item.brith_year && item.position_status === 'ครอง'">
                  <span class="font-weight-medium"
                    >{{ calcAge(item.brith_year) }} ปี</span
                  >
                  <div>
                    <v-chip
                      x-small
                      :color="
                        getRetireChipColor(item.brith_year, item.brith_month)
                      "
                      :text-color="
                        getRetireChipTextColor(
                          item.brith_year,
                          item.brith_month
                        )
                      "
                      class="mt-1"
                    >
                      {{ getRetireLabel(item.brith_year, item.brith_month) }}
                    </v-chip>
                  </div>
                </div>
                <span v-else class="grey--text">-</span>
              </template>

              <!-- ปีเกษียณ -->
              <template v-slot:item.retire_year_display="{ item }">
                <div v-if="item.brith_year && item.position_status === 'ครอง'">
                  <span class="font-weight-medium">{{
                    calcRetireYear(item.brith_year, item.brith_month)
                  }}</span>
                  <div class="text-caption grey--text">30 ก.ย.</div>
                </div>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.date_app_now="{ item }">
                <div
                  v-if="item.date_app_now && item.position_status === 'ครอง'"
                >
                  <div>{{ item.date_app_now }}</div>
                  <div
                    class="text-caption"
                    :class="getVacancyDurationClass(item.date_app_now)"
                  >
                    {{ getVacancyDuration(item.date_app_now) }}
                  </div>
                </div>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.contract_period="{ item }">
                <div v-if="item.last_contract_start && item.last_contract_end">
                  <div class="text-caption">{{ item.last_contract_start }}</div>
                  <div class="text-caption">
                    ถึง {{ item.last_contract_end }}
                  </div>
                  <v-chip
                    x-small
                    :color="
                      isContractExpiring(item.last_contract_end)
                        ? 'orange lighten-4'
                        : 'green lighten-4'
                    "
                    :text-color="
                      isContractExpiring(item.last_contract_end)
                        ? 'orange darken-3'
                        : 'green darken-3'
                    "
                    class="mt-1"
                  >
                    {{
                      isContractExpiring(item.last_contract_end)
                        ? "ใกล้หมดสัญญา"
                        : "ปกติ"
                    }}
                  </v-chip>
                </div>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.salary_s="{ item }">
                <span v-if="item.salary_s">{{
                  parseFloat(item.salary_s).toLocaleString("th-TH")
                }}</span>
                <span v-else class="grey--text">-</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 2: วิเคราะห์เกษียณ ==================== -->
        <v-tab-item>
          <v-card-text>
            <!-- สรุปด้านบน -->
            <v-alert type="info" outlined dense class="mb-4">
              <div class="d-flex align-center flex-wrap">
                <span class="mr-4">
                  <strong>ปี พ.ศ. ปัจจุบัน:</strong> {{ currentThaiYear }}
                </span>
                <span class="mr-4">
                  <strong>ผู้ครองอัตราทั้งหมด:</strong>
                  {{ summary.occupied_positions | numberFormat }} คน
                </span>
                <span class="mr-4">
                  <strong class="deep-orange--text">เกษียณปีนี้:</strong>
                  {{ retirementSummary.retire_this_year }} คน
                </span>
                <span class="mr-4">
                  <strong class="orange--text text--darken-3"
                    >เกษียณภายใน 3 ปี:</strong
                  >
                  {{ retirementSummary.retire_3years }} คน
                </span>
                <span>
                  <strong class="red--text">เกษียณภายใน 5 ปี:</strong>
                  {{ retirementSummary.retire_5years }} คน
                </span>
              </div>
            </v-alert>

            <!-- ตัวกรองปีเกษียณ -->
            <v-row dense class="mb-3">
              <v-col cols="12" sm="4" md="3">
                <v-select
                  v-model="retireFilterYear"
                  :items="retireYearOptions"
                  label="กรองปีเกษียณ"
                  clearable
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-calendar-clock"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  v-model="retireFilterUrgency"
                  :items="retireUrgencyOptions"
                  item-text="text"
                  item-value="value"
                  label="ระดับความเร่งด่วน"
                  clearable
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-alert-decagram"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                  v-model="retireSearchText"
                  label="ค้นหาชื่อ / สถานศึกษา..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- ตารางวิเคราะห์เกษียณ -->
            <v-data-table
              :headers="retirementHeaders"
              :items="filteredRetirementList"
              :loading="loading"
              :items-per-page="15"
              :footer-props="{
                'items-per-page-options': [10, 15, 30, 50, -1],
                'items-per-page-text': 'แสดงรายการ'
              }"
              class="elevation-0 report-table"
              loading-text="กำลังโหลดข้อมูล..."
              no-data-text="ไม่พบผู้ที่จะเกษียณ"
              dense
              multi-sort
            >
              <template v-slot:item.age="{ item }">
                <span class="font-weight-bold">{{ item.age }}</span>
              </template>

              <template v-slot:item.retire_year="{ item }">
                <v-chip
                  small
                  :color="
                    item.retire_year === currentThaiYear
                      ? 'deep-orange'
                      : item.years_to_retire <= 3
                      ? 'orange'
                      : 'grey lighten-2'
                  "
                  :dark="
                    item.retire_year === currentThaiYear ||
                      item.years_to_retire <= 3
                  "
                  :text-color="
                    item.years_to_retire > 3 ? 'grey darken-2' : undefined
                  "
                  class="font-weight-bold"
                >
                  {{ item.retire_year }}
                </v-chip>
              </template>

              <template v-slot:item.years_to_retire="{ item }">
                <div class="d-flex align-center">
                  <v-progress-linear
                    :value="Math.max(0, 100 - (item.years_to_retire / 5) * 100)"
                    :color="
                      item.years_to_retire === 0
                        ? 'deep-orange'
                        : item.years_to_retire <= 2
                        ? 'orange'
                        : 'teal'
                    "
                    height="18"
                    rounded
                    style="min-width: 80px; max-width: 80px"
                    class="mr-2"
                  >
                    <template v-slot:default>
                      <span class="text-caption font-weight-bold white--text">
                        {{ item.years_to_retire }}
                      </span>
                    </template>
                  </v-progress-linear>
                  <span class="text-caption">ปี</span>
                </div>
              </template>

              <template v-slot:item.urgency="{ item }">
                <v-chip
                  small
                  :color="getUrgencyColor(item.years_to_retire)"
                  dark
                  class="font-weight-medium"
                >
                  <v-icon left x-small>{{
                    getUrgencyIcon(item.years_to_retire)
                  }}</v-icon>
                  {{ getUrgencyText(item.years_to_retire) }}
                </v-chip>
              </template>

              <template v-slot:item.college_name="{ item }">
                <div>
                  <div>{{ item.college_name }}</div>
                  <div class="text-caption grey--text">
                    {{ item.region_name }} / จว.{{ item.province_name }}
                  </div>
                </div>
              </template>

              <template v-slot:item.recommendation="{ item }">
                <v-tooltip bottom max-width="300">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      small
                      :color="
                        item.years_to_retire <= 1 ? 'deep-orange' : 'grey'
                      "
                      v-on="on"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span v-if="item.years_to_retire === 0">
                    <strong>ดำเนินการทันที:</strong> เกษียณปีนี้ —
                    ควรเตรียมดึงอัตรากลับส่วนกลางเพื่อเกลี่ยอัตรากำลัง
                  </span>
                  <span v-else-if="item.years_to_retire <= 2">
                    <strong>เตรียมแผน:</strong> เกษียณภายใน
                    {{ item.years_to_retire }} ปี —
                    ควรวางแผนทดแทนอัตรากำลังและพิจารณาจัดสรรอัตราล่วงหน้า
                  </span>
                  <span v-else>
                    <strong>ติดตาม:</strong> เกษียณในอีก
                    {{ item.years_to_retire }} ปี —
                    บันทึกข้อมูลเพื่อวางแผนระยะกลาง
                  </span>
                </v-tooltip>
              </template>
            </v-data-table>

            <!-- สรุปตามภูมิภาค (เกษียณ) -->
            <v-divider class="my-5"></v-divider>
            <div class="text-subtitle-1 font-weight-bold mb-3">
              <v-icon left color="deep-orange">mdi-map-marker-multiple</v-icon>
              พยากรณ์อัตราว่างจากเกษียณ แยกตามภูมิภาค (5 ปี)
            </div>
            <v-data-table
              :headers="retireByRegionHeaders"
              :items="retireByRegionData"
              hide-default-footer
              class="elevation-0 report-table"
              dense
              no-data-text="ไม่พบข้อมูล"
            >
              <template v-slot:item.region_name="{ item }">
                <v-chip
                  small
                  color="indigo lighten-5"
                  text-color="indigo darken-2"
                >
                  <v-icon left x-small>mdi-map-marker</v-icon>
                  {{ item.region_name || "ไม่ระบุ" }}
                </v-chip>
              </template>
              <template
                v-for="yr in forecastYears"
                v-slot:[`item.y${yr}`]="{ item }"
              >
                <span
                  :key="yr"
                  :class="
                    item[`y${yr}`] > 0
                      ? 'deep-orange--text font-weight-bold'
                      : 'grey--text'
                  "
                >
                  {{ item[`y${yr}`] }}
                </span>
              </template>
              <template v-slot:item.total_5y="{ item }">
                <v-chip
                  small
                  color="red lighten-4"
                  text-color="red darken-3"
                  class="font-weight-bold"
                >
                  {{ item.total_5y }}
                </v-chip>
              </template>

              <template v-slot:body.append>
                <tr
                  class="font-weight-bold grey lighten-4"
                  v-if="retireByRegionData.length > 0"
                >
                  <td class="text-center">รวมทั้งหมด</td>
                  <td
                    v-for="yr in forecastYears"
                    :key="'ft' + yr"
                    class="text-center deep-orange--text"
                  >
                    {{ retireRegionFooter[`y${yr}`] }}
                  </td>
                  <td class="text-center">
                    <v-chip small color="red" dark class="font-weight-bold">
                      {{ retireRegionFooter.total_5y }}
                    </v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 3: สัดส่วนตามภูมิภาค ==================== -->
        <v-tab-item>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="7">
                <v-data-table
                  :headers="regionHeaders"
                  :items="regionData"
                  :loading="loading"
                  hide-default-footer
                  class="elevation-0 report-table"
                  dense
                  no-data-text="ไม่พบข้อมูล"
                >
                  <template v-slot:item.region_name="{ item }">
                    <v-chip
                      small
                      color="indigo lighten-5"
                      text-color="indigo darken-2"
                    >
                      <v-icon left x-small>mdi-map-marker</v-icon>
                      {{ item.region_name || "ไม่ระบุ" }}
                    </v-chip>
                  </template>
                  <template v-slot:item.total="{ item }">
                    <span class="font-weight-bold">{{
                      parseInt(item.total).toLocaleString()
                    }}</span>
                  </template>
                  <template v-slot:item.occupied="{ item }">
                    <span class="teal--text font-weight-medium">{{
                      parseInt(item.occupied).toLocaleString()
                    }}</span>
                  </template>
                  <template v-slot:item.vacant="{ item }">
                    <span class="red--text font-weight-medium">{{
                      parseInt(item.vacant).toLocaleString()
                    }}</span>
                  </template>
                  <template v-slot:item.percent_occupied="{ item }">
                    <div style="min-width: 150px">
                      <v-progress-linear
                        :value="
                          item.total > 0
                            ? (item.occupied / item.total) * 100
                            : 0
                        "
                        color="teal"
                        height="20"
                        rounded
                        class="white--text"
                      >
                        <template v-slot:default>
                          <span class="text-caption font-weight-bold">
                            {{
                              item.total > 0
                                ? ((item.occupied / item.total) * 100).toFixed(
                                    1
                                  )
                                : 0
                            }}%
                          </span>
                        </template>
                      </v-progress-linear>
                    </div>
                  </template>
                  <template v-slot:body.append>
                    <tr
                      class="font-weight-bold grey lighten-4"
                      v-if="regionData.length > 0"
                    >
                      <td class="text-center">รวมทั้งหมด</td>
                      <td class="text-center">
                        {{ regionTotal.total.toLocaleString() }}
                      </td>
                      <td class="text-center teal--text">
                        {{ regionTotal.occupied.toLocaleString() }}
                      </td>
                      <td class="text-center red--text">
                        {{ regionTotal.vacant.toLocaleString() }}
                      </td>
                      <td>
                        <v-progress-linear
                          :value="
                            regionTotal.total > 0
                              ? (regionTotal.occupied / regionTotal.total) * 100
                              : 0
                          "
                          color="indigo"
                          height="20"
                          rounded
                        >
                          <template v-slot:default>
                            <span
                              class="text-caption font-weight-bold white--text"
                            >
                              {{
                                regionTotal.total > 0
                                  ? (
                                      (regionTotal.occupied /
                                        regionTotal.total) *
                                      100
                                    ).toFixed(1)
                                  : 0
                              }}%
                            </span>
                          </template>
                        </v-progress-linear>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" md="5">
                <div class="text-subtitle-2 font-weight-bold mb-3 text-center">
                  สัดส่วนอัตราครอง/ว่าง แยกตามภูมิภาค
                </div>
                <div
                  v-for="item in regionData"
                  :key="item.region_name"
                  class="mb-4 px-3"
                >
                  <div class="d-flex justify-space-between mb-1">
                    <span class="text-body-2 font-weight-medium">{{
                      item.region_name || "ไม่ระบุ"
                    }}</span>
                    <span class="text-caption grey--text"
                      >{{ parseInt(item.total).toLocaleString() }} อัตรา</span
                    >
                  </div>
                  <div
                    class="d-flex"
                    style="height: 28px; border-radius: 4px; overflow: hidden;"
                  >
                    <div
                      :style="{
                        width:
                          (item.total > 0
                            ? (item.occupied / item.total) * 100
                            : 0) + '%',
                        backgroundColor: '#00897B',
                        transition: 'width 0.5s ease'
                      }"
                      class="d-flex align-center justify-center"
                    >
                      <span
                        v-if="item.occupied > 0"
                        class="white--text text-caption font-weight-bold"
                      >
                        {{ parseInt(item.occupied).toLocaleString() }}
                      </span>
                    </div>
                    <div
                      :style="{
                        width:
                          (item.total > 0
                            ? (item.vacant / item.total) * 100
                            : 0) + '%',
                        backgroundColor: '#E53935',
                        transition: 'width 0.5s ease'
                      }"
                      class="d-flex align-center justify-center"
                    >
                      <span
                        v-if="item.vacant > 0"
                        class="white--text text-caption font-weight-bold"
                      >
                        {{ parseInt(item.vacant).toLocaleString() }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-center mt-4">
                  <v-chip small color="teal" dark class="mr-2">
                    <v-icon left x-small>mdi-square</v-icon>
                    อัตราครอง
                  </v-chip>
                  <v-chip small color="red" dark>
                    <v-icon left x-small>mdi-square</v-icon>
                    อัตราว่าง
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 4: สัดส่วนตามจังหวัด ==================== -->
        <v-tab-item>
          <v-card-text>
            <v-data-table
              :headers="provinceHeaders"
              :items="provinceData"
              :loading="loading"
              :items-per-page="20"
              :footer-props="{
                'items-per-page-options': [10, 20, 50, -1],
                'items-per-page-text': 'แสดงรายการ'
              }"
              class="elevation-0 report-table"
              dense
              no-data-text="ไม่พบข้อมูล"
              multi-sort
            >
              <template v-slot:item.region_name="{ item }">
                <v-chip
                  x-small
                  color="indigo lighten-5"
                  text-color="indigo darken-2"
                >
                  {{ item.region_name || "ไม่ระบุ" }}
                </v-chip>
              </template>
              <template v-slot:item.province_name="{ item }">
                <span>{{ item.province_name || "ไม่ระบุ" }}</span>
              </template>
              <template v-slot:item.total="{ item }">
                <span class="font-weight-bold">{{
                  parseInt(item.total).toLocaleString()
                }}</span>
              </template>
              <template v-slot:item.occupied="{ item }">
                <span class="teal--text font-weight-medium">{{
                  parseInt(item.occupied).toLocaleString()
                }}</span>
              </template>
              <template v-slot:item.vacant="{ item }">
                <span class="red--text font-weight-medium">{{
                  parseInt(item.vacant).toLocaleString()
                }}</span>
              </template>
              <template v-slot:item.percent_occupied="{ item }">
                <v-progress-linear
                  :value="
                    item.total > 0 ? (item.occupied / item.total) * 100 : 0
                  "
                  color="teal"
                  height="18"
                  rounded
                  style="min-width: 120px"
                >
                  <template v-slot:default>
                    <span class="text-caption font-weight-bold">
                      {{
                        item.total > 0
                          ? ((item.occupied / item.total) * 100).toFixed(1)
                          : 0
                      }}%
                    </span>
                  </template>
                </v-progress-linear>
              </template>
              <template v-slot:item.percent_vacant="{ item }">
                <v-progress-linear
                  :value="item.total > 0 ? (item.vacant / item.total) * 100 : 0"
                  color="red lighten-1"
                  height="18"
                  rounded
                  style="min-width: 120px"
                >
                  <template v-slot:default>
                    <span class="text-caption font-weight-bold">
                      {{
                        item.total > 0
                          ? ((item.vacant / item.total) * 100).toFixed(1)
                          : 0
                      }}%
                    </span>
                  </template>
                </v-progress-linear>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 5: สรุปตามสถานศึกษา ==================== -->
        <v-tab-item>
          <v-card-text>
            <!-- สรุปด้านบน -->
            <v-alert type="info" outlined dense class="mb-4">
              <div class="d-flex align-center flex-wrap">
                <span class="mr-4"
                  ><strong>จำนวนสถานศึกษาในรายการ:</strong>
                  {{ collegeCount }} แห่ง</span
                >
                <span class="mr-4">
                  <strong class="red--text">สถานศึกษาที่มีตำแหน่งว่าง:</strong>
                  {{ collegesWithVacancyCount }} แห่ง
                </span>
                <span
                  ><strong>ประเภทตำแหน่งทั้งหมดที่พบ:</strong>
                  {{ distinctPositionTypeCount }} ประเภท</span
                >
              </div>
            </v-alert>

            <!-- ตัวกรองเฉพาะแท็บนี้ -->
            <v-row dense class="mb-3">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="collegeSummarySearch"
                  label="ค้นหาสถานศึกษา / ตำแหน่ง..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="d-flex align-center">
                <v-checkbox
                  v-model="showOnlyVacantPositions"
                  label="แสดงเฉพาะตำแหน่งที่มีอัตราว่าง"
                  color="red"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                ></v-checkbox>
              </v-col>
            </v-row>

            <!-- ตารางจัดกลุ่มตามสถานศึกษา -->
            <v-data-table
              :headers="collegeSummaryHeaders"
              :items="filteredCollegePositionSummary"
              group-by="college_name"
              :items-per-page="-1"
              hide-default-footer
              class="elevation-0 report-table college-summary-table"
              dense
              no-data-text="ไม่พบข้อมูล"
            >
              <!-- หัวกลุ่ม: แสดงชื่อสถานศึกษา + ยอดรวมของสถานศึกษานั้น -->
              <template
                v-slot:group.header="{ group, headers, toggle, isOpen }"
              >
                <td
                  :colspan="headers.length"
                  class="college-group-header"
                  @click="toggle"
                  style="cursor:pointer"
                >
                  <v-icon small class="mr-1">{{
                    isOpen ? "mdi-chevron-down" : "mdi-chevron-right"
                  }}</v-icon>
                  <v-icon small color="indigo" class="mr-1">mdi-school</v-icon>
                  <span class="font-weight-bold">{{ group }}</span>
                  <span
                    class="text-caption grey--text ml-2"
                    v-if="collegeMeta(group)"
                  >
                    ({{ collegeMeta(group).province }} /
                    {{ collegeMeta(group).region_name }})
                  </span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="indigo lighten-4"
                    text-color="indigo darken-3"
                  >
                    ทั้งหมด {{ collegeGroupTotal(group).total }}
                  </v-chip>
                  <v-chip
                    x-small
                    class="ml-1"
                    color="teal lighten-4"
                    text-color="teal darken-3"
                  >
                    ครอง {{ collegeGroupTotal(group).occupied }}
                  </v-chip>
                  <v-chip
                    x-small
                    class="ml-1"
                    :color="
                      collegeGroupTotal(group).vacant > 0
                        ? 'red lighten-4'
                        : 'grey lighten-3'
                    "
                    :text-color="
                      collegeGroupTotal(group).vacant > 0
                        ? 'red darken-3'
                        : 'grey darken-1'
                    "
                  >
                    ว่าง {{ collegeGroupTotal(group).vacant }}
                  </v-chip>
                </td>
              </template>

              <template v-slot:item.total="{ item }">
                <span class="font-weight-medium">{{ item.total }}</span>
              </template>
              <template v-slot:item.occupied="{ item }">
                <span class="teal--text font-weight-medium">{{
                  item.occupied
                }}</span>
              </template>
              <template v-slot:item.vacant="{ item }">
                <span
                  :class="
                    item.vacant > 0
                      ? 'red--text font-weight-bold'
                      : 'grey--text'
                  "
                  >{{ item.vacant }}</span
                >
              </template>
              <template v-slot:item.vacant_status="{ item }">
                <v-tooltip bottom v-if="item.vacant > 0">
                  <template v-slot:activator="{ on }">
                    <v-chip
                      small
                      color="red lighten-4"
                      text-color="red darken-3"
                      v-on="on"
                    >
                      <v-icon left x-small>mdi-alert-circle</v-icon>
                      ว่าง {{ item.vacant }} อัตรา
                    </v-chip>
                  </template>
                  <span>เลขที่อัตราว่าง: {{ item.vacant_ids.join(", ") }}</span>
                </v-tooltip>
                <v-chip
                  small
                  color="teal lighten-4"
                  text-color="teal darken-3"
                  v-else
                >
                  <v-icon left x-small>mdi-check-circle</v-icon>
                  ครบถ้วน
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- ===== SNACKBAR ===== -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";
import Manpowermenubar_govem from "../../../components/admin/manpowermenubar_govem.vue";

export default {
  name: "GovernmentEmployeeReport",
  components: {
    Manpowermenubar_govem
  },
  filters: {
    numberFormat(value) {
      if (!value && value !== 0) return "0";
      return parseInt(value).toLocaleString("th-TH");
    }
  },

  data() {
    return {
      apiUrl: "goverment_employee_report_api.php",
      apiKey: "HRvec2021",

      loading: false,
      exporting: false,
      activeTab: 0,
      searchText: "",

      // แก้ไข: เปลี่ยน province -> province_name ให้ตรงกับ v-model ใน template
      // และตรงกับพารามิเตอร์ที่ API ใช้กรอง (pro.province_name) หลังแก้ไข API แล้ว
      filters: {
        region_name: null,
        province_name: null,
        college_code: null,
        name_postion: null
      },

      filterOptions: {
        regions: [],
        provinces: [],
        positions: [],
        colleges: []
      },

      summary: {
        total_positions: 0,
        vacant_positions: 0,
        occupied_positions: 0
      },

      positionList: [],
      regionData: [],
      provinceData: [],

      // Retirement filters
      retireFilterYear: null,
      retireFilterUrgency: null,
      retireSearchText: "",

      retireUrgencyOptions: [
        { text: "เกษียณปีนี้", value: "now" },
        { text: "ภายใน 2 ปี", value: "2y" },
        { text: "ภายใน 3 ปี", value: "3y" },
        { text: "ภายใน 5 ปี", value: "5y" }
      ],

      // Table Headers
      positionHeaders: [
        { text: "ลำดับ", value: "id_no", width: 70, align: "center" },
        {
          text: "เลขที่อัตรา",
          value: "id_position",
          width: 90,
          align: "center"
        },
        { text: "สถานะ", value: "position_status", width: 90, align: "center" },
        { text: "ชื่อ-สกุล ผู้ครอง", value: "full_name", width: 170 },
        { text: "อายุ", value: "age_display", width: 110, align: "center" },
        {
          text: "ปีเกษียณ",
          value: "retire_year_display",
          width: 90,
          align: "center"
        },
        { text: "ตำแหน่ง", value: "name_postion", width: 180 },
        { text: "สถานศึกษา", value: "college_name", width: 180 },
        { text: "จังหวัด", value: "province_name", width: 80, align: "center" },
        { text: "ภูมิภาค", value: "region_name", width: 90, align: "center" },
        {
          text: "วันที่ครองอัตรา",
          value: "date_app_now",
          width: 130,
          align: "center"
        },
        {
          text: "สัญญาจ้าง",
          value: "contract_period",
          width: 140,
          align: "center",
          sortable: false
        },
        { text: "เงินเดือน", value: "salary_s", width: 100, align: "right" }
      ],

      retirementHeaders: [
        {
          text: "เลขที่อัตรา",
          value: "id_position",
          width: 90,
          align: "center"
        },
        { text: "ชื่อ-สกุล", value: "full_name", width: 180 },
        { text: "อายุ (ปี)", value: "age", width: 80, align: "center" },
        {
          text: "ปีเกษียณ (พ.ศ.)",
          value: "retire_year",
          width: 110,
          align: "center"
        },
        {
          text: "วันเกษียณ",
          value: "retire_date_display",
          width: 110,
          align: "center"
        },
        {
          text: "เหลืออีก",
          value: "years_to_retire",
          width: 130,
          align: "center"
        },
        { text: "ระดับ", value: "urgency", width: 130, align: "center" },
        { text: "ตำแหน่ง", value: "name_postion", width: 180 },
        { text: "สถานศึกษา", value: "college_name", width: 200 },
        {
          text: "แนะนำ",
          value: "recommendation",
          width: 70,
          align: "center",
          sortable: false
        }
      ],

      regionHeaders: [
        { text: "ภูมิภาค", value: "region_name", align: "center", width: 140 },
        { text: "อัตราทั้งหมด", value: "total", align: "center", width: 110 },
        { text: "อัตราครอง", value: "occupied", align: "center", width: 100 },
        { text: "อัตราว่าง", value: "vacant", align: "center", width: 100 },
        { text: "อัตราการครอง", value: "percent_occupied", width: 180 }
      ],

      provinceHeaders: [
        { text: "จังหวัด", value: "province_name", width: 120 },
        { text: "ภูมิภาค", value: "region_name", align: "center", width: 120 },
        { text: "อัตราทั้งหมด", value: "total", align: "center", width: 110 },
        { text: "อัตราครอง", value: "occupied", align: "center", width: 100 },
        { text: "อัตราว่าง", value: "vacant", align: "center", width: 100 },
        { text: "% ครอง", value: "percent_occupied", width: 150 },
        { text: "% ว่าง", value: "percent_vacant", width: 150 }
      ],

      snackbar: { show: false, text: "", color: "success" },
      collegeSummarySearch: "",
      showOnlyVacantPositions: false,

      collegeSummaryHeaders: [
        { text: "ตำแหน่ง", value: "name_postion", width: 260 },
        { text: "ทั้งหมด", value: "total", align: "center", width: 90 },
        { text: "ครอง", value: "occupied", align: "center", width: 90 },
        { text: "ว่าง", value: "vacant", align: "center", width: 90 },
        {
          text: "สถานะอัตรา",
          value: "vacant_status",
          align: "center",
          width: 150,
          sortable: false
        }
      ]
    };
  },

  computed: {
    currentThaiYear() {
      return new Date().getFullYear() + 543;
    },

    forecastYears() {
      const base = this.currentThaiYear;
      return [base, base + 1, base + 2, base + 3, base + 4];
    },

    retireYearOptions() {
      const years = new Set();
      this.retirementList.forEach(r => years.add(r.retire_year));
      return Array.from(years).sort();
    },

    filteredProvinces() {
      if (!this.filters.region_name) return this.filterOptions.provinces;
      return this.filterOptions.provinces.filter(
        p => p.region_name === this.filters.region_name
      );
    },

    regionTotal() {
      return this.regionData.reduce(
        (acc, item) => {
          acc.total += parseInt(item.total) || 0;
          acc.occupied += parseInt(item.occupied) || 0;
          acc.vacant += parseInt(item.vacant) || 0;
          return acc;
        },
        { total: 0, occupied: 0, vacant: 0 }
      );
    },

    // ===== คำนวณรายชื่อเกษียณจาก positionList (client-side) =====
    // หลักราชการไทย: เกษียณ 30 ก.ย. ของปีที่อายุครบ 60
    // เกิด ต.ค.-ธ.ค. → ปีเกษียณ = ปีเกิด + 61 (สิ้นปีงบฯ ถัดไป)
    // เกิด ม.ค.-ก.ย. → ปีเกษียณ = ปีเกิด + 60
    retirementList() {
      const thisYear = this.currentThaiYear;
      return this.positionList
        .filter(item => {
          if (item.position_status !== "ครอง") return false;
          if (!item.brith_year) return false;
          const by = parseInt(item.brith_year);
          if (isNaN(by) || by <= 0) return false;
          const bm = parseInt(item.brith_month);
          const retireYear = bm >= 10 && bm <= 12 ? by + 61 : by + 60;
          return retireYear >= thisYear && retireYear <= thisYear + 10;
        })
        .map(item => {
          const by = parseInt(item.brith_year);
          const bm = parseInt(item.brith_month);
          const retireYear = bm >= 10 && bm <= 12 ? by + 61 : by + 60;
          const age = thisYear - by;
          const yearsToRetire = retireYear - thisYear;
          return {
            id_position: item.id_position,
            id_no: item.id_no,
            full_name: item.full_name,
            brith_year: item.brith_year,
            brith_month: item.brith_month,
            brith_day: item.brith_day,
            age: age,
            retire_year: retireYear,
            retire_date_display: `30 ก.ย. ${retireYear}`,
            years_to_retire: yearsToRetire,
            name_postion: item.name_postion,
            college_code: item.college_code,
            college_name: item.college_name,
            province: item.province_name,
            region_name: item.region_name,
            salary_s: item.salary_s,
            level_edd: item.level_edd,
            ed_name: item.ed_name
          };
        })
        .sort((a, b) => a.retire_year - b.retire_year || b.age - a.age);
    },

    filteredRetirementList() {
      let list = this.retirementList;

      if (this.retireFilterYear) {
        list = list.filter(r => r.retire_year === this.retireFilterYear);
      }

      if (this.retireFilterUrgency) {
        switch (this.retireFilterUrgency) {
          case "now":
            list = list.filter(r => r.years_to_retire === 0);
            break;
          case "2y":
            list = list.filter(r => r.years_to_retire <= 2);
            break;
          case "3y":
            list = list.filter(r => r.years_to_retire <= 3);
            break;
          case "5y":
            list = list.filter(r => r.years_to_retire <= 5);
            break;
        }
      }

      if (this.retireSearchText) {
        const q = this.retireSearchText.toLowerCase();
        list = list.filter(
          r =>
            (r.full_name && r.full_name.toLowerCase().includes(q)) ||
            (r.college_name && r.college_name.toLowerCase().includes(q)) ||
            (r.id_position && String(r.id_position).includes(q))
        );
      }

      return list;
    },

    retirementSummary() {
      const thisYear = this.currentThaiYear;
      const list = this.retirementList;
      return {
        retire_this_year: list.filter(r => r.retire_year === thisYear).length,
        retire_3years: list.filter(r => r.years_to_retire <= 3).length,
        retire_5years: list.filter(r => r.years_to_retire <= 5).length
      };
    },

    retirementForecast() {
      const thisYear = this.currentThaiYear;
      const result = [];
      let cumulative = 0;
      for (let i = 0; i < 5; i++) {
        const yr = thisYear + i;
        const count = this.retirementList.filter(r => r.retire_year === yr)
          .length;
        cumulative += count;
        result.push({ year: yr, count: count, cumulative: cumulative });
      }
      return result;
    },

    retireByRegionHeaders() {
      const cols = [
        { text: "ภูมิภาค", value: "region_name", align: "center", width: 140 }
      ];
      this.forecastYears.forEach(yr => {
        cols.push({
          text: `พ.ศ. ${yr}`,
          value: `y${yr}`,
          align: "center",
          width: 90
        });
      });
      cols.push({
        text: "รวม 5 ปี",
        value: "total_5y",
        align: "center",
        width: 100
      });
      return cols;
    },

    retireByRegionData() {
      const regionMap = {};
      this.retirementList.forEach(r => {
        const rn = r.region_name || "ไม่ระบุ";
        if (!regionMap[rn]) {
          regionMap[rn] = { region_name: rn, total_5y: 0 };
          this.forecastYears.forEach(yr => (regionMap[rn][`y${yr}`] = 0));
        }
        if (
          r.retire_year >= this.forecastYears[0] &&
          r.retire_year <= this.forecastYears[4]
        ) {
          regionMap[rn][`y${r.retire_year}`]++;
          regionMap[rn].total_5y++;
        }
      });
      return Object.values(regionMap).sort((a, b) =>
        a.region_name.localeCompare(b.region_name, "th")
      );
    },

    retireRegionFooter() {
      const ft = { total_5y: 0 };
      this.forecastYears.forEach(yr => (ft[`y${yr}`] = 0));
      this.retireByRegionData.forEach(row => {
        this.forecastYears.forEach(yr => (ft[`y${yr}`] += row[`y${yr}`]));
        ft.total_5y += row.total_5y;
      });
      return ft;
    },
    // ===== สรุปตำแหน่งต่อสถานศึกษา (คำนวณฝั่ง client จาก positionList) =====
    collegePositionSummary() {
      const map = {};
      this.positionList.forEach(item => {
        const key = `${item.college_code}||${item.name_postion}`;
        if (!map[key]) {
          map[key] = {
            college_code: item.college_code,
            college_name: item.college_name || "ไม่ระบุสถานศึกษา",
            province: item.province_name,
            region_name: item.region_name,
            name_postion: item.name_postion || "ไม่ระบุตำแหน่ง",
            total: 0,
            occupied: 0,
            vacant: 0,
            vacant_ids: []
          };
        }
        map[key].total++;
        if (item.position_status === "ครอง") {
          map[key].occupied++;
        } else {
          map[key].vacant++;
          map[key].vacant_ids.push(item.id_position);
        }
      });
      return Object.values(map).sort(
        (a, b) =>
          a.college_name.localeCompare(b.college_name, "th") ||
          a.name_postion.localeCompare(b.name_postion, "th")
      );
    },

    filteredCollegePositionSummary() {
      let list = this.collegePositionSummary;

      if (this.showOnlyVacantPositions) {
        list = list.filter(r => r.vacant > 0);
      }

      if (this.collegeSummarySearch) {
        const q = this.collegeSummarySearch.toLowerCase();
        list = list.filter(
          r =>
            (r.college_name && r.college_name.toLowerCase().includes(q)) ||
            (r.name_postion && r.name_postion.toLowerCase().includes(q))
        );
      }

      return list;
    },

    collegeCount() {
      return new Set(
        this.filteredCollegePositionSummary.map(r => r.college_name)
      ).size;
    },

    collegesWithVacancyCount() {
      return new Set(
        this.filteredCollegePositionSummary
          .filter(r => r.vacant > 0)
          .map(r => r.college_name)
      ).size;
    },

    distinctPositionTypeCount() {
      return new Set(
        this.filteredCollegePositionSummary.map(r => r.name_postion)
      ).size;
    },

    // ===== ใหม่: จัดกลุ่มทุกตำแหน่งของแต่ละสถานศึกษาให้อยู่ใน "1 แถว" =====
    // ใช้สำหรับ Sheet 7 ตอน export — แทนที่จะมี 1 แถวต่อ 1 ตำแหน่งต่อสถานศึกษา
    // (เหมือน collegePositionSummary เดิม) จะรวมทุกตำแหน่งของสถานศึกษาเดียวกัน
    // ไว้ในแถวเดียว โดยคอลัมน์ "ตำแหน่ง" จะแจกแจงแต่ละตำแหน่งพร้อมจำนวน
    // (คั่นด้วยการขึ้นบรรทัดใหม่ — เปิด "Wrap Text" ในคอลัมน์นี้เพื่อดูครบทุกบรรทัด)
    collegeSummaryGrouped() {
      const map = {};
      this.collegePositionSummary.forEach(item => {
        const key = item.college_code || item.college_name;
        if (!map[key]) {
          map[key] = {
            college_name: item.college_name,
            province: item.province,
            region_name: item.region_name,
            positions: [],
            total: 0,
            occupied: 0,
            vacant: 0,
            vacant_ids: []
          };
        }
        map[key].positions.push({
          name_postion: item.name_postion,
          total: item.total,
          occupied: item.occupied,
          vacant: item.vacant
        });
        map[key].total += item.total;
        map[key].occupied += item.occupied;
        map[key].vacant += item.vacant;
        if (item.vacant_ids && item.vacant_ids.length) {
          map[key].vacant_ids.push(...item.vacant_ids);
        }
      });
      return Object.values(map).sort((a, b) =>
        a.college_name.localeCompare(b.college_name, "th")
      );
    }
  },

  mounted() {
    this.fetchFilters();
    this.fetchAllData();
  },

  methods: {
    // ยอดรวมของสถานศึกษาหนึ่ง ๆ (ใช้ในหัวกลุ่มของตาราง)
    collegeGroupTotal(collegeName) {
      return this.filteredCollegePositionSummary
        .filter(r => r.college_name === collegeName)
        .reduce(
          (acc, r) => {
            acc.total += r.total;
            acc.occupied += r.occupied;
            acc.vacant += r.vacant;
            return acc;
          },
          { total: 0, occupied: 0, vacant: 0 }
        );
    },

    // ดึงจังหวัด/ภูมิภาคของสถานศึกษา สำหรับแสดงข้าง ๆ ชื่อในหัวกลุ่ม
    collegeMeta(collegeName) {
      return this.collegePositionSummary.find(
        r => r.college_name === collegeName
      );
    },
    async apiCall(action, extraParams = {}) {
      const payload = { ApiKey: this.apiKey, action: action, ...extraParams };
      const response = await this.$http.post(
        this.apiUrl,
        JSON.stringify(payload)
      );
      return response.data;
    },

    async fetchFilters() {
      try {
        const data = await this.apiCall("filters");
        if (!data.error) {
          this.filterOptions.regions = data.regions || [];
          this.filterOptions.provinces = data.provinces || [];
          this.filterOptions.positions = data.positions || [];
          this.filterOptions.colleges = data.colleges || [];
        }
      } catch (e) {
        console.error("Error fetching filters:", e);
      }
    },

    async fetchAllData() {
      this.loading = true;
      try {
        const params = {};
        if (this.filters.region_name)
          params.region_name = this.filters.region_name;
        // แก้ไข: ใช้ province_name แทน province ให้ตรงกับ data() และ API ที่แก้แล้ว
        if (this.filters.province_name)
          params.province_name = this.filters.province_name;
        if (this.filters.college_code)
          params.college_code = this.filters.college_code;
        if (this.filters.name_postion)
          params.name_postion = this.filters.name_postion;

        const [
          summaryData,
          listData,
          regionRes,
          provinceRes
        ] = await Promise.all([
          this.apiCall("summary", params),
          this.apiCall("position_list", params),
          this.apiCall("by_region", params),
          this.apiCall("by_province", params)
        ]);

        if (!summaryData.error) this.summary = summaryData;
        if (Array.isArray(listData)) this.positionList = listData;
        if (Array.isArray(regionRes)) this.regionData = regionRes;
        if (Array.isArray(provinceRes)) this.provinceData = provinceRes;
      } catch (e) {
        console.error("Error fetching data:", e);
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error");
      } finally {
        this.loading = false;
      }
    },

    onRegionChange() {
      // แก้ไข: ล้างค่า province_name (เดิมล้าง this.filters.province ที่ไม่มีจริง)
      this.filters.province_name = null;
    },

    clearFilters() {
      this.filters = {
        region_name: null,
        province_name: null,
        college_code: null,
        name_postion: null
      };
      this.retireFilterYear = null;
      this.retireFilterUrgency = null;
      this.retireSearchText = "";
      this.fetchAllData();
    },

    // ===== คำนวณปีเกษียณ (หลักราชการไทย) =====
    // เกิด ม.ค.-ก.ย. (เดือน 1-9) → เกษียณ 30 ก.ย. ของปี เกิด+60
    // เกิด ต.ค.-ธ.ค. (เดือน 10-12) → เกษียณ 30 ก.ย. ของปี เกิด+60+1
    // เพราะ ณ 30 ก.ย. ปีนั้น ยังอายุไม่ครบ 60 ปีบริบูรณ์
    getRetireYearBE(brithYear, brithMonth) {
      const by = parseInt(brithYear);
      const bm = parseInt(brithMonth);
      if (isNaN(by) || by <= 0) return null;
      // ถ้าไม่มีเดือนเกิด ให้ default เป็นเกษียณปกติ (ปี+60)
      if (isNaN(bm) || bm <= 0 || bm > 12) return by + 60;
      // เกิดหลังกันยายน (ต.ค. พ.ย. ธ.ค.) → +1 ปี
      return bm >= 10 ? by + 60 + 1 : by + 60;
    },

    // ===== คำนวณอายุจากปีเกิด พ.ศ. =====
    calcAge(brithYear) {
      if (!brithYear) return "-";
      const by = parseInt(brithYear);
      if (isNaN(by) || by <= 0) return "-";
      return this.currentThaiYear - by;
    },

    calcRetireYear(brithYear, brithMonth) {
      const ry = this.getRetireYearBE(brithYear, brithMonth);
      return ry || "-";
    },

    getRetireLabel(brithYear, brithMonth) {
      const ry = this.getRetireYearBE(brithYear, brithMonth);
      if (!ry) return "";
      const diff = ry - this.currentThaiYear;
      if (diff <= 0) return "เกษียณปีนี้";
      return `เกษียณอีก ${diff} ปี`;
    },

    getRetireChipColor(brithYear, brithMonth) {
      const ry = this.getRetireYearBE(brithYear, brithMonth);
      if (!ry) return "grey lighten-3";
      const diff = ry - this.currentThaiYear;
      if (diff <= 0) return "deep-orange lighten-4";
      if (diff <= 2) return "orange lighten-4";
      if (diff <= 5) return "amber lighten-4";
      return "grey lighten-3";
    },

    getRetireChipTextColor(brithYear, brithMonth) {
      const ry = this.getRetireYearBE(brithYear, brithMonth);
      if (!ry) return "grey darken-1";
      const diff = ry - this.currentThaiYear;
      if (diff <= 0) return "deep-orange darken-4";
      if (diff <= 2) return "orange darken-4";
      if (diff <= 5) return "amber darken-4";
      return "grey darken-1";
    },

    getUrgencyColor(yearsToRetire) {
      if (yearsToRetire <= 0) return "deep-orange darken-1";
      if (yearsToRetire <= 2) return "orange darken-1";
      if (yearsToRetire <= 3) return "amber darken-2";
      return "blue-grey";
    },
    getUrgencyIcon(yearsToRetire) {
      if (yearsToRetire <= 0) return "mdi-alert-circle";
      if (yearsToRetire <= 2) return "mdi-alert";
      if (yearsToRetire <= 3) return "mdi-clock-alert";
      return "mdi-clock-outline";
    },
    getUrgencyText(yearsToRetire) {
      if (yearsToRetire <= 0) return "เกษียณปีนี้";
      if (yearsToRetire <= 2) return "เร่งด่วน";
      if (yearsToRetire <= 3) return "เตรียมแผน";
      return "ติดตาม";
    },

    getVacancyDuration(dateStr) {
      if (!dateStr) return "";
      const parts = dateStr.split("-");
      if (parts.length !== 3) return "";
      const date = new Date(parts[0], parts[1] - 1, parts[2]);
      const now = new Date();
      const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
      const years = Math.floor(diffDays / 365);
      const months = Math.floor((diffDays % 365) / 30);
      if (years > 0) return `${years} ปี ${months} เดือน`;
      if (months > 0) return `${months} เดือน`;
      return `${diffDays} วัน`;
    },

    getVacancyDurationClass(dateStr) {
      if (!dateStr) return "grey--text";
      const parts = dateStr.split("-");
      if (parts.length !== 3) return "grey--text";
      const date = new Date(parts[0], parts[1] - 1, parts[2]);
      const now = new Date();
      const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
      if (diffDays > 365 * 3) return "red--text font-weight-bold";
      if (diffDays > 365) return "orange--text";
      return "grey--text";
    },

    isContractExpiring(endDateStr) {
      if (!endDateStr) return false;
      const parts = endDateStr.split("-");
      if (parts.length !== 3) return false;
      const endDate = new Date(parts[0], parts[1] - 1, parts[2]);
      const now = new Date();
      const diffDays = Math.floor((endDate - now) / (1000 * 60 * 60 * 24));
      return diffDays >= 0 && diffDays <= 180;
    },

    // ===== Export Excel =====
    async exportExcel() {
      if (this.positionList.length === 0) {
        this.showSnackbar("ไม่มีข้อมูลสำหรับส่งออก", "warning");
        return;
      }

      this.exporting = true;
      try {
        const wb = XLSX.utils.book_new();
        const thisYear = this.currentThaiYear;

        // Sheet 1: รายละเอียดอัตรา (+ อายุ + ปีเกษียณ)
        const sheet1Data = this.positionList.map((item, idx) => {
          const by = parseInt(item.brith_year);
          const bm = parseInt(item.brith_month);
          const age = !isNaN(by) && by > 0 ? thisYear - by : "";
          const retireYr =
            !isNaN(by) && by > 0
              ? bm >= 10 && bm <= 12
                ? by + 61
                : by + 60
              : "";
          const yearsLeft = retireYr ? retireYr - thisYear : "";
          return {
            ลำดับ: idx + 1,
            เลขที่อัตรา: item.id_position,
            สถานะ: item.position_status,
            "ชื่อ-สกุล": item.full_name || "-",
            "วัน/เดือน/ปีเกิด (พ.ศ.)":
              item.brith_day && item.brith_month && item.brith_year
                ? `${item.brith_day}/${item.brith_month}/${item.brith_year}`
                : item.brith_year || "-",
            "อายุ (ปี)": age,
            "ปีเกษียณ (พ.ศ.)": retireYr,
            วันเกษียณ: retireYr ? `30 ก.ย. ${retireYr}` : "-",
            "เหลืออีก (ปี)": yearsLeft,
            ตำแหน่ง: item.name_postion,
            สถานศึกษา: item.college_name,
            จังหวัด: item.province_name,
            ภูมิภาค: item.region_name,
            วันที่ครองอัตรา: item.date_app_now || "-",
            ระยะเวลาครอง: item.date_app_now
              ? this.getVacancyDuration(item.date_app_now)
              : "-",
            สัญญาเริ่ม: item.last_contract_start || "-",
            สัญญาสิ้นสุด: item.last_contract_end || "-",
            เงินเดือน: item.salary_s ? parseFloat(item.salary_s) : 0,
            วุฒิการศึกษา: item.level_edd || "-",
            สาขา: item.ed_name || "-"
          };
        });
        const ws1 = XLSX.utils.json_to_sheet(sheet1Data);
        ws1["!cols"] = [
          { wch: 6 },
          { wch: 12 },
          { wch: 8 },
          { wch: 25 },
          { wch: 14 },
          { wch: 10 },
          { wch: 16 },
          { wch: 14 },
          { wch: 30 },
          { wch: 30 },
          { wch: 12 },
          { wch: 12 },
          { wch: 14 },
          { wch: 16 },
          { wch: 14 },
          { wch: 14 },
          { wch: 12 },
          { wch: 25 },
          { wch: 25 }
        ];
        XLSX.utils.book_append_sheet(wb, ws1, "รายละเอียดอัตรา");

        // Sheet 2: วิเคราะห์เกษียณ
        const sheet2Data = this.retirementList.map((item, idx) => ({
          ลำดับ: idx + 1,
          เลขที่อัตรา: item.id_position,
          "ชื่อ-สกุล": item.full_name,
          "วัน/เดือน/ปีเกิด": `${item.brith_day || "-"}/${item.brith_month ||
            "-"}/${item.brith_year}`,
          "อายุ (ปี)": item.age,
          "ปีเกษียณ (พ.ศ.)": item.retire_year,
          วันเกษียณ: item.retire_date_display,
          "เหลืออีก (ปี)": item.years_to_retire,
          ระดับความเร่งด่วน: this.getUrgencyText(item.years_to_retire),
          ตำแหน่ง: item.name_postion,
          สถานศึกษา: item.college_name,
          จังหวัด: item.province_name,
          ภูมิภาค: item.region_name,
          เงินเดือน: item.salary_s ? parseFloat(item.salary_s) : 0
        }));
        const ws2 = XLSX.utils.json_to_sheet(sheet2Data);
        ws2["!cols"] = [
          { wch: 6 },
          { wch: 12 },
          { wch: 25 },
          { wch: 10 },
          { wch: 16 },
          { wch: 14 },
          { wch: 18 },
          { wch: 30 },
          { wch: 30 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 }
        ];
        XLSX.utils.book_append_sheet(wb, ws2, "วิเคราะห์เกษียณ");

        // Sheet 3: พยากรณ์เกษียณตามภูมิภาค 5 ปี
        const sheet3Data = this.retireByRegionData.map(item => {
          const row = { ภูมิภาค: item.region_name };
          this.forecastYears.forEach(yr => {
            row[`พ.ศ. ${yr}`] = item[`y${yr}`];
          });
          row["รวม 5 ปี"] = item.total_5y;
          return row;
        });
        const footerRow = { ภูมิภาค: "รวมทั้งหมด" };
        this.forecastYears.forEach(yr => {
          footerRow[`พ.ศ. ${yr}`] = this.retireRegionFooter[`y${yr}`];
        });
        footerRow["รวม 5 ปี"] = this.retireRegionFooter.total_5y;
        sheet3Data.push(footerRow);
        const ws3 = XLSX.utils.json_to_sheet(sheet3Data);
        ws3["!cols"] = [
          { wch: 15 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 }
        ];
        XLSX.utils.book_append_sheet(wb, ws3, "เกษียณตามภูมิภาค");

        // Sheet 4: ตามภูมิภาค
        const sheet4Data = this.regionData.map(item => ({
          ภูมิภาค: item.region_name || "ไม่ระบุ",
          อัตราทั้งหมด: parseInt(item.total),
          อัตราครอง: parseInt(item.occupied),
          อัตราว่าง: parseInt(item.vacant),
          "อัตราการครอง (%)":
            item.total > 0
              ? parseFloat(((item.occupied / item.total) * 100).toFixed(1))
              : 0
        }));
        const ws4 = XLSX.utils.json_to_sheet(sheet4Data);
        ws4["!cols"] = [
          { wch: 15 },
          { wch: 14 },
          { wch: 12 },
          { wch: 12 },
          { wch: 16 }
        ];
        XLSX.utils.book_append_sheet(wb, ws4, "ตามภูมิภาค");

        // Sheet 5: ตามจังหวัด
        const sheet5Data = this.provinceData.map(item => ({
          จังหวัด: item.province_name || "ไม่ระบุ",
          ภูมิภาค: item.region_name || "ไม่ระบุ",
          อัตราทั้งหมด: parseInt(item.total),
          อัตราครอง: parseInt(item.occupied),
          อัตราว่าง: parseInt(item.vacant),
          "อัตราการครอง (%)":
            item.total > 0
              ? parseFloat(((item.occupied / item.total) * 100).toFixed(1))
              : 0
        }));
        const ws5 = XLSX.utils.json_to_sheet(sheet5Data);
        ws5["!cols"] = [
          { wch: 15 },
          { wch: 15 },
          { wch: 14 },
          { wch: 12 },
          { wch: 12 },
          { wch: 16 }
        ];
        XLSX.utils.book_append_sheet(wb, ws5, "ตามจังหวัด");

        // Sheet 6: สรุปภาพรวม
        const sheet6Data = [
          { รายการ: "อัตราทั้งหมด", จำนวน: this.summary.total_positions },
          { รายการ: "อัตราครอง", จำนวน: this.summary.occupied_positions },
          { รายการ: "อัตราว่าง", จำนวน: this.summary.vacant_positions },
          {
            รายการ: `เกษียณปีนี้ (${thisYear})`,
            จำนวน: this.retirementSummary.retire_this_year
          },
          {
            รายการ: "เกษียณภายใน 3 ปี",
            จำนวน: this.retirementSummary.retire_3years
          },
          {
            รายการ: "เกษียณภายใน 5 ปี",
            จำนวน: this.retirementSummary.retire_5years
          },
          {
            รายการ: "อัตราว่าง + เกษียณ 5 ปี (ที่ต้องเกลี่ย)",
            จำนวน:
              this.summary.vacant_positions +
              this.retirementSummary.retire_5years
          }
        ];
        const ws6 = XLSX.utils.json_to_sheet(sheet6Data);
        ws6["!cols"] = [{ wch: 40 }, { wch: 14 }];
        XLSX.utils.book_append_sheet(wb, ws6, "สรุปภาพรวม");

        // Sheet 7: สรุปตำแหน่งตามสถานศึกษา
        // แก้ไข: เดิม 1 แถว = 1 ตำแหน่ง ต่อ 1 สถานศึกษา (สถานศึกษาเดียวกันซ้ำหลายแถว)
        // เปลี่ยนเป็น 1 แถว = 1 สถานศึกษา โดยรวมทุกตำแหน่งของสถานศึกษานั้น
        // ไว้ในคอลัมน์ "ตำแหน่ง" เดียว (ขึ้นบรรทัดใหม่คั่นแต่ละตำแหน่ง)
        // หมายเหตุ: ไลบรารี xlsx เวอร์ชัน community ไม่รองรับการตั้งค่า wrap text
        // ผ่านโค้ด — เปิด "Wrap Text" ที่คอลัมน์นี้เองใน Excel เพื่อดูครบทุกบรรทัด
        const sheet7Data = this.collegeSummaryGrouped.map(col => ({
          สถานศึกษา: col.college_name,
          จังหวัด: col.province || "ไม่ระบุ",
          ภูมิภาค: col.region_name || "ไม่ระบุ",
          ตำแหน่ง: col.positions
            .map(
              p =>
                `${p.name_postion} (ทั้งหมด ${p.total} / ครอง ${p.occupied} / ว่าง ${p.vacant})`
            )
            .join("\n"),
          ทั้งหมด: col.total,
          ครอง: col.occupied,
          ว่าง: col.vacant,
          เลขที่อัตราว่าง: col.vacant_ids.join(", ") || "-"
        }));
        const ws7 = XLSX.utils.json_to_sheet(sheet7Data);
        ws7["!cols"] = [
          { wch: 30 },
          { wch: 14 },
          { wch: 12 },
          { wch: 45 },
          { wch: 10 },
          { wch: 10 },
          { wch: 10 },
          { wch: 30 }
        ];
        XLSX.utils.book_append_sheet(wb, ws7, "สรุปตามสถานศึกษา");

        const now = new Date();
        const dateStr = `${now.getFullYear()}${String(
          now.getMonth() + 1
        ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}`;
        XLSX.writeFile(wb, `รายงานกรอบอัตรากำลัง_เกษียณ_${dateStr}.xlsx`);
        this.showSnackbar("ส่งออกข้อมูล Excel สำเร็จ", "success");
      } catch (e) {
        console.error("Export error:", e);
        this.showSnackbar("เกิดข้อผิดพลาดในการส่งออก", "error");
      } finally {
        this.exporting = false;
      }
    },

    showSnackbar(text, color = "success") {
      this.snackbar = { show: true, text, color };
    }
  }
};
</script>

<style scoped>
.header-card {
  border-left: 4px solid #3949ab;
}
.summary-card {
  border-radius: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}
.total-card {
  border-top: 3px solid #3949ab;
}
.occupied-card {
  border-top: 3px solid #00897b;
}
.vacant-card {
  border-top: 3px solid #e53935;
}
.retire-card {
  border-top: 3px solid #e64a19;
}

.forecast-chip {
  border-radius: 8px !important;
  transition: all 0.2s ease;
}
.forecast-chip:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.forecast-chip--active {
  border-color: #e64a19 !important;
  border-width: 2px;
  background-color: #fbe9e7 !important;
}

.report-table >>> .v-data-table-header th {
  background-color: #f5f5f5 !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  white-space: nowrap;
}
.report-table >>> tbody tr:hover {
  background-color: #e8eaf6 !important;
}

@media (max-width: 600px) {
  .text-h4 {
    font-size: 1.5rem !important;
  }
  .text-h5 {
    font-size: 1.1rem !important;
  }
}

.college-group-header {
  background-color: #eef1fb !important;
  padding: 10px 12px !important;
}
.college-summary-table >>> .v-row-group__header {
  background-color: #eef1fb !important;
}
</style>